module.exports = __webpack_public_path__ + "img/referral-link-copied.6ca5b7b2.svg";